import { capitalizeWord } from '../../utils/utils'

export const checkFormaPagamento = (forma) => {
  const regex = /Visa|Master|Amex|Elo|Diners|Boleto|Bonificação|Pix/

  if (typeof forma === 'string') {
    return regex.exec(capitalizeWord(forma))[0]
  }
}

// export const remessasMock = [
//   {
//     SellerId: 1,
//     SellerNome: 'Precode - Teste Sandbox',
//     Itens: [
//       {
//         IdProduto: 75850,
//         DescricaoResumida:
//           'Brinquedo Recreativo para Gatos Aranha Mimo Pet - PP225',
//         Quantidade: 1,
//         PrecoVenda: 'R$ 24,90',
//         ValorDesconto: 'R$ 0,00',
//         ValorTotal: 'R$ 24,90',
//         IdFilial: 1,
//         Filial: 'Barueri                       ',
//         IdObjetoMedia: 120254
//       }
//     ],
//     NumeroNotaFiscal: null,
//     NotaFiscal: null,
//     Envio: null,
//     Tracking: [
//       {
//         Id: 0,
//         PedidoSituacao: 'PEDIDO_EFETUADO',
//         DescricaoStatus: 'PEDIDO EFETUADO',
//         DataHoraMovimentacao: '2022-05-02T11:02:21.067'
//       },
//       {
//         Id: 1568,
//         PedidoSituacao: 'PEDIDO_EFETUADO',
//         DescricaoStatus: 'PEDIDO EFETUADO',
//         DataHoraMovimentacao: '2022-05-02T11:02:21.067'
//       },
//       {
//         Id: 1570,
//         PedidoSituacao: 'SEPARACAO_DE_PRODUTO',
//         DescricaoStatus: 'AGUARDANDO SEPARAÇÃO',
//         DataHoraMovimentacao: '2022-05-02T11:13:25.18'
//       }
//     ]
//   },

//   //========== SELLER ============
//   {
//     SellerId: 34,
//     SellerNome: 'Amauri Surf Shop',
//     Itens: [
//       {
//         IdProduto: 75940,
//         DescricaoResumida:
//           'Ração para Cachorro Pedigree Carne, Frango e Cereais 10,1Kg',
//         Quantidade: 1,
//         PrecoVenda: 'R$ 108,90',
//         ValorDesconto: 'R$ 11,00',
//         ValorTotal: 'R$ 108,90',
//         IdFilial: 1,
//         Filial: 'Barueri                       ',
//         IdObjetoMedia: 120337
//       }
//     ],
//     NumeroNotaFiscal: null,
//     NotaFiscal: {
//       Chave: '23432432432432432423432432444444444444444444',
//       Situacao: 'AUTORIZADA',
//       Numero: '043423432',
//       Serie: '432',
//       CFOP: '    ',
//       EstadoRegistro: 'ISENTO',
//       Data: '2022-05-02T11:30:00',
//       LinkXML: '',
//       LinkDANFE: '',
//       MensagemSefaz: null,
//       Observacao: null
//     },
//     Envio: {
//       DataEnvio: '02/05/2022',
//       DataEstimadaEntrega: '07/05/2022',
//       Transportadora: 'Correios Sedex',
//       CodigoRastreio: '424242',
//       RastreioUrl:
//         'http://www.replicade.com.br/rastreioInterno.php?cod=424242egge6eggeMjkxMjM1NDAwMDAxNDQ='
//       // ''
//     },
//     Tracking: [
//       {
//         Id: 0,
//         PedidoSituacao: 'PEDIDO_EFETUADO',
//         DescricaoStatus: 'PEDIDO EFETUADO',
//         DataHoraMovimentacao: '2022-05-02T11:02:22.167'
//       },
//       {
//         Id: 1569,
//         PedidoSituacao: 'PEDIDO_EFETUADO',
//         DescricaoStatus: 'PEDIDO EFETUADO',
//         DataHoraMovimentacao: '2022-05-02T11:02:22.167'
//       },
//       {
//         Id: 1571,
//         PedidoSituacao: 'SEPARACAO_DE_PRODUTO',
//         DescricaoStatus: 'AGUARDANDO SEPARAÇÃO',
//         DataHoraMovimentacao: '2022-05-02T11:13:26.18'
//       },
//       {
//         Id: 1572,
//         PedidoSituacao: 'EMISSAO_DE_NOTA_FISCAL',
//         DescricaoStatus: 'EMISSÃO DE NOTA FISCAL',
//         DataHoraMovimentacao: '2022-05-02T11:30:10.047'
//       },
//       {
//         Id: 1573,
//         PedidoSituacao: 'PEDIDO_EM_TRANSPORTE',
//         DescricaoStatus: 'AGUARDANDO TRANSPORTE',
//         DataHoraMovimentacao: '2022-05-02T11:30:58.09'
//       }
//     ]
//   },

//   // ========== GIMBA =========== //
//   {
//     SellerId: null,
//     SellerNome: 'Gimba',
//     Itens: [
//       {
//         IdProduto: 18940,
//         DescricaoResumida: 'Cartucho HP 662XL 6,5ml Preto Original CZ105AB',
//         Quantidade: 1,
//         PrecoVenda: 'R$ 94,91',
//         ValorDesconto: 'R$ 12,74',
//         ValorTotal: 'R$ 94,91',
//         IdFilial: 1,
//         Filial: 'Barueri                       ',
//         IdObjetoMedia: 72322
//       },
//       {
//         IdProduto: 68736,
//         DescricaoResumida: 'Cerveja Skol Pilsen Lata 269ml 1 UN',
//         Quantidade: 1,
//         PrecoVenda: 'R$ 1,89',
//         ValorDesconto: 'R$ 0,36',
//         ValorTotal: 'R$ 1,89',
//         IdFilial: 1,
//         Filial: 'Barueri                       ',
//         IdObjetoMedia: 103592
//       },
//       {
//         IdProduto: 18423,
//         DescricaoResumida: 'Copo Plástico 180ml Branco CX 2500 UN Ecocoppo',
//         Quantidade: 1,
//         PrecoVenda: 'R$ 136,04',
//         ValorDesconto: 'R$ 15,11',
//         ValorTotal: 'R$ 136,04',
//         IdFilial: 1,
//         Filial: 'Barueri                       ',
//         IdObjetoMedia: 110372
//       }
//     ],
//     NumeroNotaFiscal: null,
//     NotaFiscal: null,
//     Envio: {
//       DataEnvio: null,
//       DataEstimadaEntrega: null,
//       Transportadora: null,
//       CodigoRastreio: '4543252345',
//       RastreioUrl:
//         'https://rastreamento.correios.com.br/app/index.php?objetos=4543252345'
//     },
//     Tracking: [
//       {
//         Id: 11844476,
//         PedidoSituacao: 'PROCESSAMENTO_PEDIDO',
//         DescricaoStatus: '',
//         DataHoraMovimentacao: '2022-05-02T10:58:00'
//       },
//       {
//         Id: 11844477,
//         PedidoSituacao: 'PEDIDO_EFETUADO',
//         DescricaoStatus: 'PEDIDO EFETUADO',
//         DataHoraMovimentacao: '2022-05-02T11:02:00'
//       },
//       {
//         Id: 11844478,
//         PedidoSituacao: 'PEDIDO_EFETUADO',
//         DescricaoStatus: 'PEDIDO EFETUADO',
//         DataHoraMovimentacao: '2022-05-02T11:02:00'
//       },
//       {
//         Id: 11844479,
//         PedidoSituacao: 'SEPARACAO_DE_PRODUTO',
//         DescricaoStatus: 'AGUARDANDO SEPARAÇÃO',
//         DataHoraMovimentacao: '2022-05-02T11:12:00'
//       },
//       {
//         Id: 11844480,
//         PedidoSituacao: 'EMISSAO_DE_NOTA_FISCAL',
//         DescricaoStatus: 'EMISSÃO DE NOTA FISCAL',
//         DataHoraMovimentacao: '2022-05-02T11:12:00'
//       },
//       {
//         Id: 11844481,
//         PedidoSituacao: 'PEDIDO_EM_TRANSPORTE',
//         DescricaoStatus: 'AGUARDANDO TRANSPORTE',
//         DataHoraMovimentacao: '2022-05-02T11:12:00'
//       }
//     ]
//   }
// ]
